import { makeEnvironment } from '../../../../environments/make-environment';
import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../../common/log/log/log-service-factory';
import { IEntityService } from './entity-service';
import { EntityServiceImpl } from './entity-service-impl';

let entityService: IEntityService;

export function makeEntityService() {
  if (!entityService) {
    entityService = new EntityServiceImpl(
      makeLogService(),
      makeAuthService(),
      makeEnvironment(),
    );
  }
  return entityService;
}
